<template>
	<div v-if="allErrors.length > 0" class="content has-background-danger has-text-white">
		<p style="margin-bottom: 0.75rem;">Please address the following matters and then try signing up again.</p>
		<ul style="list-style-type: none;">
			<li v-for="errorPair in allErrors" :key="errorPair[0]">
				<span v-if="errorPair[0] !== null">
					<span style="font-weight: bold;">{{ errorPair[0] }}: </span> {{ errorPair[1] }}
				</span>
				<span v-else>
					{{ errorPair[1] }}
				</span>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: "SignupErrors",
		props: {
			errors: {
				type: Object,
				required: true,
			},
			indexToPlayerName: {
				type: Object,
				required: true,
			},
			firstPlayerLabel: {
				type: String,
				required: true,
			},
			pluralize: {
				type: Function,
				required: true,
			},
		},
		computed: {
			allErrors() {
				let errors = [];
				for (let [key, value] of Object.entries(this.errors)) {
					if (key == 'captain' || key == 'player') {
						errors = errors.concat(this.firstPlayerErrors(value));
					} else if (key == 'players') {
						errors = errors.concat(this.playersErrors(value));
					} else if (key == 'name') {
						errors.push(["Team Name", value]);
					} else if (key == 'nonFieldErrors') {
						// The backend is smart about providing a helpful error message here.
						errors.push([null, value[0]]);
					} else {
						// In case there is another error that we didn't handle (there shouldn't be).
						errors.push([key, value]);
					}
				}
				return errors;
			},
		},
		methods: {
			indexedPlayerErrorLabel(index, key) {
				let firstPart = this.pluralize(`${this.indexToPlayerName[index]} Player`);
				return `${firstPart} ${this.playerErrorMapping[key]}`;
			},
			playersErrors(errors) {
				let playersErrors = [];
				// Since we want to be one ahead we start at `1`.
				let index = 1;
				for (let error of errors) {
					for (let [key, message] of Object.entries(error)) {
						playersErrors.push([this.indexedPlayerErrorLabel(index, key), message[0]]);
					}
					++index;
				}
				return playersErrors;
			},
			firstPlayerErrors(error) {
				let firstPlayerErrors = [];
				for (let [key, message] of Object.entries(error)) {
					let errorLabel = `${this.pluralize(this.firstPlayerLabel)} ${this.playerErrorMapping[key]}`;
					firstPlayerErrors.push([errorLabel, message[0]]);
				}
				return firstPlayerErrors;
			},
		},
		created() {
			this.playerErrorMapping = {
				'name': 'Name',
				'email': 'Email',
				'phoneNumber': 'Phone Number',
			}
		}
	}
</script>